const initialState = {
  leadsSelected: [],
  columnsSelected: [],
  loading: true,
  leadsData: [],
  totalLeads: 0,
  error: null,
  tableRequestId: null,
  leadsRequestId: null,
  leadsFlowId: null,
  activeCard: null,
  sourceColumnId: null,
  targetColumnId: null,
  loadingComments: false,
  reassignContacts: false,
  notSelectedModal: {
    isOpen: false,
    key: '',
  },
  changeStatusModal: {
    leadList: [],
    leadSelected: false,
    loading: false,
    isOpen: false,
  },
  closeLeadModal: {
    loadingTags: true,
    loadingClosingExcuses: true,
    closingLeads: false,
    isOpen: false,
    selectingTags: false,
    comments: '',
    tags: [],
    tagsToAdd: [],
    closingExcuses: [],
    selectedClosingExcuse: null,
  },
  reasignModal: {
    agentsList: [],
    agentSelected: null,
    loading: false,
    isOpen: false,
  },
  search: {
    value: '',
    item: null,
  },
  showSearch: false,
  opportunitiesRevision: 0,
  dismissedSharkTankNotices: [],
};

export default initialState;
